/**
 * Class representing a LightboxManager.
 * Manages the display of a lightbox containing an iframe video content.
 * Requirements:
 * - A specific template needs to be present in the HTML with the ID 'lightbox-template'.
 * - A specific div container needs to be present in the HTML with the ID 'lightbox-container'.
 */
class LightboxManager {
	constructor() {
		this.container = document.getElementById('lightbox-container');
		this.template = document.getElementById('lightbox-template');
		this.body = document.body;
	}

	/**
	 * Populates and displays the lightbox with an iframe video content.
	 *
	 * @param {string} videoSrc - The source URL of an iframe.
	 * @param {string} title - The title of the video. Default is an empty string.
	 * @param {string} description - The description of the video. Default is an empty string.
	 */
	populate(videoSrc, title = '', description = '') {
		const lightbox = this.template.content.cloneNode(true).querySelector('.lightbox');
		const lightboxWrapper = lightbox.querySelector('.lightbox__video-wrapper');

		const titleElement = lightbox.querySelector('.lightbox__title');
		if (titleElement && title) {
			titleElement.textContent = title;
		}

		const descriptionElement = lightbox.querySelector('.lightbox__description');
		if (descriptionElement && description) {
			descriptionElement.textContent = description;
		}

		const iframe = document.createElement('iframe');
		iframe.src = videoSrc;
		iframe.frameBorder = '0';
		iframe.scrolling = 'no';
		iframe.allowFullscreen = true;

		this.body.classList.add('lightbox-open');
		lightboxWrapper.appendChild(iframe); // Embedding iframe into document

		const closeButton = lightbox.querySelector('.lightbox__close-btn');
		closeButton.addEventListener('click', () => {
			this.body.classList.remove('lightbox-open');
			this.container.innerHTML = ''; // Clear content after lightbox close
			lightbox.style.display = 'none';
		});

		/**
		 * Close the lightbox on esc key
		*/
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				this.body.classList.remove('lightbox-open');
				this.container.innerHTML = '';
				lightbox.style.display = 'none';
			}
		});

		this.container.innerHTML = ''; // Clear previous content(lightbox)
		this.container.appendChild(lightbox);

		lightbox.style.display = 'block';
	}
}

window.lightboxManager = new LightboxManager();
